export const countryData = [{
    countryCode: "AF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
    Iso: "+93",
    name: "Afghanistan"
}, {
    countryCode: "AX",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg",
    Iso: "+358",
    name: "Åland Islands"
}, {
    countryCode: "AL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
    Iso: "+355",
    name: "Albania"
}, {
    countryCode: "DZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
    Iso: "+213",
    name: "Algeria"
}, {
    countryCode: "AS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
    Iso: "+1684",
    name: "American Samoa"
}, {
    countryCode: "AD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
    Iso: "+376",
    name: "Andorra"
}, {
    countryCode: "AO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
    Iso: "+244",
    name: "Angola"
}, {
    countryCode: "AI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
    Iso: "+1264",
    name: "Anguilla"
}, {
    countryCode: "AQ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg",
    Iso: "+672",
    name: "Antarctica"
}, {
    countryCode: "AR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
    Iso: "+54",
    name: "Argentina"
}, {
    countryCode: "AM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
    Iso: "+374",
    name: "Armenia"
}, {
    countryCode: "AW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
    Iso: "+297",
    name: "Aruba"
}, {
    countryCode: "AU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
    Iso: "+61",
    name: "Australia"
}, {
    countryCode: "AT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
    Iso: "+43",
    name: "Austria"
}, {
    countryCode: "AZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
    Iso: "+994",
    name: "Azerbaijan"
}, {
    countryCode: "BS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
    Iso: "+1242",
    name: "Bahamas"
}, {
    countryCode: "BH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
    Iso: "+973",
    name: "Bahrain"
}, {
    countryCode: "BD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
    Iso: "+880",
    name: "Bangladesh"
}, {
    countryCode: "BB",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
    Iso: "+1246",
    name: "Barbados"
}, {
    countryCode: "BY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
    Iso: "+375",
    name: "Belarus"
}, {
    countryCode: "BE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
    Iso: "+32",
    name: "Belgium"
}, {
    countryCode: "BZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
    Iso: "+501",
    name: "Belize"
}, {
    countryCode: "BJ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
    Iso: "+229",
    name: "Benin"
}, {
    countryCode: "BM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
    Iso: "+1441",
    name: "Bermuda"
}, {
    countryCode: "BT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
    Iso: "+975",
    name: "Bhutan"
}, {
    countryCode: "BW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
    Iso: "+267",
    name: "Botswana"
}, {
    countryCode: "BV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BV.svg",
    Iso: "+47",
    name: "Bouvet Island"
}, {
    countryCode: "BR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
    Iso: "+55",
    name: "Brazil"
}, {
    countryCode: "IO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
    Iso: "+246",
    name: "British Indian Ocean Territory"
}, {
    countryCode: "BG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
    Iso: "+359",
    name: "Bulgaria"
}, {
    countryCode: "BF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
    Iso: "+226",
    name: "Burkina Faso"
}, {
    countryCode: "BI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
    Iso: "+257",
    name: "Burundi"
}, {
    countryCode: "KH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
    Iso: "+855",
    name: "Cambodia"
}, {
    countryCode: "CM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
    Iso: "+237",
    name: "Cameroon"
}, {
    countryCode: "CA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
    Iso: "+1",
    name: "Canada"
}, {
    countryCode: "CV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
    Iso: "+238",
    name: "Cape Verde"
}, {
    countryCode: "KY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
    Iso: "+ 345",
    name: "Cayman Islands"
}, {
    countryCode: "CF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
    Iso: "+236",
    name: "Central African Republic"
}, {
    countryCode: "TD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
    Iso: "+235",
    name: "Chad"
}, {
    countryCode: "CL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
    Iso: "+56",
    name: "Chile"
}, {
    countryCode: "CN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
    Iso: "+86",
    name: "China"
}, {
    countryCode: "CX",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
    Iso: "+61",
    name: "Christmas Island"
}, {
    countryCode: "CC",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg",
    Iso: "+61",
    name: "Cocos (Keeling) Islands"
}, {
    countryCode: "CO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
    Iso: "+57",
    name: "Colombia"
}, {
    countryCode: "KM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
    Iso: "+269",
    name: "Comoros"
}, {
    countryCode: "CK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
    Iso: "+682",
    name: "Cook Islands"
}, {
    countryCode: "CR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
    Iso: "+506",
    name: "Costa Rica"
}, {
    countryCode: "HR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
    Iso: "+385",
    name: "Croatia"
}, {
    countryCode: "CU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
    Iso: "+53",
    name: "Cuba"
}, {
    countryCode: "CY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
    Iso: "+357",
    name: "Cyprus"
}, {
    countryCode: "DK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
    Iso: "+45",
    name: "Denmark"
}, {
    countryCode: "DJ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
    Iso: "+253",
    name: "Djibouti"
}, {
    countryCode: "DM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
    Iso: "+1767",
    name: "Dominica"
}, {
    countryCode: "DO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
    Iso: "+1849",
    name: "Dominican Republic"
}, {
    countryCode: "EC",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
    Iso: "+593",
    name: "Ecuador"
}, {
    countryCode: "EG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
    Iso: "+20",
    name: "Egypt"
}, {
    countryCode: "SV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
    Iso: "+503",
    name: "El Salvador"
}, {
    countryCode: "GQ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
    Iso: "+240",
    name: "Equatorial Guinea"
}, {
    countryCode: "ER",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
    Iso: "+291",
    name: "Eritrea"
}, {
    countryCode: "EE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
    Iso: "+372",
    name: "Estonia"
}, {
    countryCode: "ET",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
    Iso: "+251",
    name: "Ethiopia"
}, {
    countryCode: "FO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
    Iso: "+298",
    name: "Faroe Islands"
}, {
    countryCode: "FJ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
    Iso: "+679",
    name: "Fiji"
}, {
    countryCode: "FI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg",
    Iso: "+358",
    name: "Finland"
}, {
    countryCode: "FR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
    Iso: "+33",
    name: "France"
}, {
    countryCode: "GF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
    Iso: "+594",
    name: "French Guiana"
}, {
    countryCode: "PF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
    Iso: "+689",
    name: "French Polynesia"
}, {
    countryCode: "TF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg",
    Iso: "+262",
    name: "French Southern Territories"
}, {
    countryCode: "GA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
    Iso: "+241",
    name: "Gabon"
}, {
    countryCode: "GM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
    Iso: "+220",
    name: "Gambia"
}, {
    countryCode: "GE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
    Iso: "+995",
    name: "Georgia"
}, {
    countryCode: "DE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
    Iso: "+49",
    name: "Germany"
}, {
    countryCode: "GH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
    Iso: "+233",
    name: "Ghana"
}, {
    countryCode: "GI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
    Iso: "+350",
    name: "Gibraltar"
}, {
    countryCode: "GR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
    Iso: "+30",
    name: "Greece"
}, {
    countryCode: "GL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
    Iso: "+299",
    name: "Greenland"
}, {
    countryCode: "GD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
    Iso: "+1473",
    name: "Grenada"
}, {
    countryCode: "GP",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
    Iso: "+590",
    name: "Guadeloupe"
}, {
    countryCode: "GU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
    Iso: "+1671",
    name: "Guam"
}, {
    countryCode: "GT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
    Iso: "+502",
    name: "Guatemala"
}, {
    countryCode: "GG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg",
    Iso: "+44",
    name: "Guernsey"
}, {
    countryCode: "GN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
    Iso: "+224",
    name: "Guinea"
}, {
    countryCode: "GW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
    Iso: "+245",
    name: "Guinea-Bissau"
}, {
    countryCode: "GY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
    Iso: "+592",
    name: "Guyana"
}, {
    countryCode: "HT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
    Iso: "+509",
    name: "Haiti"
}, {
    countryCode: "HN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
    Iso: "+504",
    name: "Honduras"
}, {
    countryCode: "HU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
    Iso: "+36",
    name: "Hungary"
}, {
    countryCode: "IS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
    Iso: "+354",
    name: "Iceland"
}, {
    countryCode: "IN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
    Iso: "+91",
    name: "India"
}, {
    countryCode: "ID",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
    Iso: "+62",
    name: "Indonesia"
}, {
    countryCode: "IQ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
    Iso: "+964",
    name: "Iraq"
}, {
    countryCode: "IE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
    Iso: "+353",
    name: "Ireland"
}, {
    countryCode: "IM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg",
    Iso: "+44",
    name: "Isle of Man"
}, {
    countryCode: "IL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
    Iso: "+972",
    name: "Israel"
}, {
    countryCode: "IT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
    Iso: "+39",
    name: "Italy"
}, {
    countryCode: "JM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
    Iso: "+1876",
    name: "Jamaica"
}, {
    countryCode: "JP",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg",
    Iso: "+81",
    name: "Japan"
}, {
    countryCode: "JE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg",
    Iso: "+44",
    name: "Jersey"
}, {
    countryCode: "JO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
    Iso: "+962",
    name: "Jordan"
}, {
    countryCode: "KZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
    Iso: "+7",
    name: "Kazakhstan"
}, {
    countryCode: "KE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
    Iso: "+254",
    name: "Kenya"
}, {
    countryCode: "KI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
    Iso: "+686",
    name: "Kiribati"
}, {
    countryCode: "XK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/XK.svg",
    Iso: "+383",
    name: "Kosovo"
}, {
    countryCode: "KW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
    Iso: "+965",
    name: "Kuwait"
}, {
    countryCode: "KG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
    Iso: "+996",
    name: "Kyrgyzstan"
}, {
    countryCode: "LA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
    Iso: "+856",
    name: "Laos"
}, {
    countryCode: "LV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
    Iso: "+371",
    name: "Latvia"
}, {
    countryCode: "LB",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
    Iso: "+961",
    name: "Lebanon"
}, {
    countryCode: "LS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
    Iso: "+266",
    name: "Lesotho"
}, {
    countryCode: "LR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
    Iso: "+231",
    name: "Liberia"
}, {
    countryCode: "LI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
    Iso: "+423",
    name: "Liechtenstein"
}, {
    countryCode: "LT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
    Iso: "+370",
    name: "Lithuania"
}, {
    countryCode: "LU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
    Iso: "+352",
    name: "Luxembourg"
}, {
    countryCode: "MG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
    Iso: "+261",
    name: "Madagascar"
}, {
    countryCode: "MW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
    Iso: "+265",
    name: "Malawi"
}, {
    countryCode: "MY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
    Iso: "+60",
    name: "Malaysia"
}, {
    countryCode: "MV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
    Iso: "+960",
    name: "Maldives"
}, {
    countryCode: "ML",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
    Iso: "+223",
    name: "Mali"
}, {
    countryCode: "MT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
    Iso: "+356",
    name: "Malta"
}, {
    countryCode: "MH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
    Iso: "+692",
    name: "Marshall Islands"
}, {
    countryCode: "MQ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
    Iso: "+596",
    name: "Martinique"
}, {
    countryCode: "MR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
    Iso: "+222",
    name: "Mauritania"
}, {
    countryCode: "MU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
    Iso: "+230",
    name: "Mauritius"
}, {
    countryCode: "YT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
    Iso: "+262",
    name: "Mayotte"
}, {
    countryCode: "MX",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
    Iso: "+52",
    name: "Mexico"
}, {
    countryCode: "MD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
    Iso: "+373",
    name: "Moldova"
}, {
    countryCode: "MC",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
    Iso: "+377",
    name: "Monaco"
}, {
    countryCode: "MN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
    Iso: "+976",
    name: "Mongolia"
}, {
    countryCode: "ME",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
    Iso: "+382",
    name: "Montenegro"
}, {
    countryCode: "MS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
    Iso: "+1664",
    name: "Montserrat"
}, {
    countryCode: "MA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
    Iso: "+212",
    name: "Morocco"
}, {
    countryCode: "MZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg",
    Iso: "+258",
    name: "Mozambique"
}, {
    countryCode: "NA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
    Iso: "+264",
    name: "Namibia"
}, {
    countryCode: "NR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
    Iso: "+674",
    name: "Nauru"
}, {
    countryCode: "NP",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
    Iso: "+977",
    name: "Nepal"
}, {
    countryCode: "NL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
    Iso: "+31",
    name: "Netherlands"
}, {
    countryCode: "NC",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
    Iso: "+687",
    name: "New Caledonia"
}, {
    countryCode: "NZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
    Iso: "+64",
    name: "New Zealand"
}, {
    countryCode: "NI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
    Iso: "+505",
    name: "Nicaragua"
}, {
    countryCode: "NE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
    Iso: "+227",
    name: "Niger"
}, {
    countryCode: "NG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
    Iso: "+234",
    name: "Nigeria"
}, {
    countryCode: "NU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
    Iso: "+683",
    name: "Niue"
}, {
    countryCode: "NF",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
    Iso: "+672",
    name: "Norfolk Island"
}, {
    countryCode: "MP",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
    Iso: "+1670",
    name: "Northern Mariana Islands"
}, {
    countryCode: "NO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
    Iso: "+47",
    name: "Norway"
}, {
    countryCode: "OM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
    Iso: "+968",
    name: "Oman"
}, {
    countryCode: "PK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
    Iso: "+92",
    name: "Pakistan"
}, {
    countryCode: "PW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
    Iso: "+680",
    name: "Palau"
}, {
    countryCode: "PA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
    Iso: "+507",
    name: "Panama"
}, {
    countryCode: "PG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
    Iso: "+675",
    name: "Papua New Guinea"
}, {
    countryCode: "PY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
    Iso: "+595",
    name: "Paraguay"
}, {
    countryCode: "PE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
    Iso: "+51",
    name: "Peru"
}, {
    countryCode: "PH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
    Iso: "+63",
    name: "Philippines"
}, {
    countryCode: "PL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
    Iso: "+48",
    name: "Poland"
}, {
    countryCode: "PT",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
    Iso: "+351",
    name: "Portugal"
}, {
    countryCode: "PR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
    Iso: "+1939",
    name: "Puerto Rico"
}, {
    countryCode: "QA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
    Iso: "+974",
    name: "Qatar"
}, {
    countryCode: "RO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
    Iso: "+40",
    name: "Romania"
}, {
    countryCode: "RU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
    Iso: "+7",
    name: "Russia"
}, {
    countryCode: "RW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
    Iso: "+250",
    name: "Rwanda"
}, {
    countryCode: "WS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
    Iso: "+685",
    name: "Samoa"
}, {
    countryCode: "SM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
    Iso: "+378",
    name: "San Marino"
}, {
    countryCode: "SA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
    Iso: "+966",
    name: "Saudi Arabia"
}, {
    countryCode: "SN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
    Iso: "+221",
    name: "Senegal"
}, {
    countryCode: "RS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
    Iso: "+381",
    name: "Serbia"
}, {
    countryCode: "SC",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
    Iso: "+248",
    name: "Seychelles"
}, {
    countryCode: "SL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
    Iso: "+232",
    name: "Sierra Leone"
}, {
    countryCode: "SG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
    Iso: "+65",
    name: "Singapore"
}, {
    countryCode: "SK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
    Iso: "+421",
    name: "Slovakia"
}, {
    countryCode: "SI",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
    Iso: "+386",
    name: "Slovenia"
}, {
    countryCode: "SB",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
    Iso: "+677",
    name: "Solomon Islands"
}, {
    countryCode: "SO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg",
    Iso: "+252",
    name: "Somalia"
}, {
    countryCode: "ZA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
    Iso: "+27",
    name: "South Africa"
}, {
    countryCode: "SS",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg",
    Iso: "+211",
    name: "South Sudan"
}, {
    countryCode: "ES",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
    Iso: "+34",
    name: "Spain"
}, {
    countryCode: "LK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
    Iso: "+94",
    name: "Sri Lanka"
}, {
    countryCode: "SD",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
    Iso: "+249",
    name: "Sudan"
}, {
    countryCode: "SR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
    Iso: "+597",
    name: "Suriname"
}, {
    countryCode: "SE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
    Iso: "+46",
    name: "Sweden"
}, {
    countryCode: "CH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
    Iso: "+41",
    name: "Switzerland"
}, {
    countryCode: "TW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
    Iso: "+886",
    name: "Taiwan"
}, {
    countryCode: "TJ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
    Iso: "+992",
    name: "Tajikistan"
}, {
    countryCode: "TH",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
    Iso: "+66",
    name: "Thailand"
}, {
    countryCode: "TL",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg",
    Iso: "+670",
    name: "Timor-Leste"
}, {
    countryCode: "TG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
    Iso: "+228",
    name: "Togo"
}, {
    countryCode: "TK",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
    Iso: "+690",
    name: "Tokelau"
}, {
    countryCode: "TO",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
    Iso: "+676",
    name: "Tonga"
}, {
    countryCode: "TN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
    Iso: "+216",
    name: "Tunisia"
}, {
    countryCode: "TR",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
    Iso: "+90",
    name: "Turkey"
}, {
    countryCode: "TM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
    Iso: "+993",
    name: "Turkmenistan"
}, {
    countryCode: "TV",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
    Iso: "+688",
    name: "Tuvalu"
}, {
    countryCode: "UG",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
    Iso: "+256",
    name: "Uganda"
}, {
    countryCode: "UA",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
    Iso: "+380",
    name: "Ukraine"
}, {
    countryCode: "AE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
    Iso: "+971",
    name: "United Arab Emirates"
}, {
    countryCode: "GB",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
    Iso: "+44",
    name: "United Kingdom"
}, {
    countryCode: "US",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
    Iso: "+1",
    name: "United States"
}, {
    countryCode: "UY",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
    Iso: "+598",
    name: "Uruguay"
}, {
    countryCode: "UZ",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
    Iso: "+998",
    name: "Uzbekistan"
}, {
    countryCode: "VU",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
    Iso: "+678",
    name: "Vanuatu"
}, {
    countryCode: "VN",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
    Iso: "+84",
    name: "Vietnam"
}, {
    countryCode: "YE",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
    Iso: "+967",
    name: "Yemen"
}, {
    countryCode: "ZM",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
    Iso: "+260",
    name: "Zambia"
}, {
    countryCode: "ZW",
    image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
    Iso: "+263",
    name: "Zimbabwe"
}]